export default __webpack_public_path__ + "static/media/Trevor.cc02b31d.png";